import { IDateTimeWithZone } from "../common/date-time-with-zone.interface";
import { IAuditInfo } from "../message-models/audit-info.interface";

export class AuditInfo implements IAuditInfo {
  companyName: string;
  companyId: string;
  auditId: string;
  updatedBy: string;
  auditDate: IDateTimeWithZone;
  auditAction: string;
  operation: string;
  entityType: string;
  auditString: string;

  constructor(auditInfo: IAuditInfo) {
    this.companyName = auditInfo.companyName;
    this.companyId = auditInfo.companyId;
    this.auditId = auditInfo.auditId;
    this.updatedBy = auditInfo.updatedBy;
    this.auditDate = auditInfo.auditDate;
    this.auditAction = auditInfo.auditAction;
    this.operation = auditInfo.operation;
    this.entityType = auditInfo.entityType;
    this.auditString = auditInfo.auditString;
  }
}
